import React from 'react'
import { useTranslation } from 'react-i18next'

import { eventLogger } from '~/shared/services/eventLogger'

export const TermsOfUseLink: React.FC = () => {
  const { t } = useTranslation()

  return (
    <a
      href="https://quiz.mygrowth.one/terms-of-use#"
      onClick={() => eventLogger.logTermsOfUseClicked()}
      target="_blank"
      rel="noopener noreferrer"
    >
      {t`commonComponents.termsOfUse`}
    </a>
  )
}
